module.exports = __webpack_public_path__ + "img/home-hero-image_small.5506a2b3.webp";